(function () {
  var locked = window.LRLUX_LAUNCH || {};
  var RELOAD_KEY = 'lrlux-launch-reload';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatTime(diff) {
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
    return pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  function isLockedVariant(id) {
    var ts = locked[String(id)];
    return ts && ts * 1000 > Date.now();
  }

  function onLaunched() {
    var done = sessionStorage.getItem(RELOAD_KEY);
    var url = new URL(window.location.href);
    if (done) {
      sessionStorage.removeItem(RELOAD_KEY);
      url.searchParams.set('_launch', Date.now());
      window.location.replace(url.toString());
      return;
    }
    sessionStorage.setItem(RELOAD_KEY, '1');
    window.location.reload();
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var launched = false;

    document.querySelectorAll('[data-lrlux-launch]').forEach(function (el) {
      var diff = Number(el.dataset.lrluxLaunch) - now;
      if (diff <= 0) {
        launched = true;
        return;
      }
      var out = el.querySelector('[data-lrlux-launch-time]');
      if (out) out.textContent = formatTime(diff);
    });

    document.querySelectorAll('[data-lrlux-launch-block]').forEach(function (block) {
      var diff = Number(block.dataset.lrluxLaunchBlock) - now;
      if (diff <= 0) {
        launched = true;
        return;
      }
      var parts = {
        days: Math.floor(diff / 86400),
        hours: Math.floor((diff % 86400) / 3600),
        minutes: Math.floor((diff % 3600) / 60),
        seconds: diff % 60
      };
      Object.keys(parts).forEach(function (key) {
        var node = block.querySelector('[data-lrlux-launch-' + key + ']');
        if (node) node.textContent = pad(parts[key]);
      });
    });

    if (launched) {
      clearInterval(timer);
      onLaunched();
    }
  }

  function localizeDates() {
    document.querySelectorAll('[data-lrlux-launch-date]').forEach(function (el) {
      var date = new Date(Number(el.dataset.lrluxLaunchDate) * 1000);
      if (Number.isNaN(date.getTime())) return;
      el.textContent = date.toLocaleString(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      });
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var idField = form.querySelector('[name="id"]');
      if (!idField || !isLockedVariant(idField.value)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest('[data-variant-id]');
      if (!trigger || !isLockedVariant(trigger.getAttribute('data-variant-id'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  localizeDates();
  tick();
  var timer = setInterval(tick, 1000);
})();
